import { ReactNode } from "react";
import { swingHeroSVG } from "swing-assets";

import { translate } from "~utils";

type SwingHeroImageWrapperProps = {
  children: ReactNode;
};

export function SwingHeroImageWrapper(props: SwingHeroImageWrapperProps) {
  const { children } = props;

  return (
    <div
      css={{
        display: "inline-block",
        position: "relative",
        width: "fit-content",
        marginLeft: 2,
        border: "1px solid var(--swing-yellow600)",
        padding: 4,
        borderRadius: "50%",
        backgroundColor: "var(--swing-yellow200)",
        marginBottom: 10,
      }}
    >
      {children}
      <p
        css={{
          display: "flex",
          left: "27%",
          bottom: -16,
          margin: 0,
          fontSize: 12,
          alignItems: "center",
          columnGap: 4,
          color: "var(--swing-blue600)",
          fontWeight: 600,
          position: "absolute",
          transform: "translateX(-48%)",
          pointerEvents: "none",
        }}
      >
        {translate("SUB_PROFILE_CONTACT_SWING")}
        <img src={swingHeroSVG} alt="Swing Hero icon" />
        {translate("SUB_PROFILE_CONTACT_HERO")}
      </p>
    </div>
  );
}
